import React, { Component } from 'react';
import { Colors } from '../colors';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import AppBar from '@mui/material/AppBar';
import OrdersByTimeAndRegion from '../screens/OrdersByTimeRegion';
import MapScreen from '../screens/MapScreen';
import { Localization } from '../localization';

import ShowDriversScreen from '../screens/ShowDriversScreen';
import DamagesScreen from '../screens/DamagesScreen';
import CustomerLoyalty from '../screens/CustomerLoyalty';


class MainMenu extends Component {


  state = {
    tabValue: 0
  }


  renderTab = () => {

    if (this.state.tabValue === 0)
      return <ShowDriversScreen />

    if (this.state.tabValue === 1)
      return <OrdersByTimeAndRegion />

    if (this.state.tabValue === 2)
      return <MapScreen />

    if (this.state.tabValue === 3)
      return <DamagesScreen />

    if (this.state.tabValue === 4)
      return <CustomerLoyalty />
  }


  handleChange = (event, newValue) => {
    this.setState({ tabValue: newValue })
  }

  render() {
    return (
      <div style={styles.container} >

        <AppBar position="static" color="default">
          <Tabs
            value={this.state.tabValue}
            onChange={this.handleChange}
            indicatorColor="primary"
            variant="fullWidth"
            aria-label="full width tabs example"
          >
            <Tab label={Localization.Farsi.showDrivers} />
            <Tab label={Localization.Farsi.ordersByRegion} />
            <Tab label={Localization.Farsi.map} />
            <Tab label={Localization.Farsi.damages} />
            <Tab label={Localization.Farsi.customerLoyalty} />


          </Tabs>
        </AppBar>

        {this.renderTab()}

      </div>
    );
  }
}





export default MainMenu


const styles = {


  backgroundImage: {
    justifyContent: 'center',
    WebkitBoxPack: 'center',
    alignItems: 'center', WebkitBoxAlign: 'center',
    backgroundColor: Colors.PurpleBorder,
    flex: 1,
    width: '100%',
    height: '100%'
  },
  modalStyles: {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)'
    }
  },
  container: {
    display: '-webkit-box',
    display: '-moz-box',
    display: '-ms-flexbox',
    display: '-webkit-flex',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 'calc(100vh - 40px)',
    WebkitBoxOrient: 'vertical',
    WebkitBoxDirection: 'normal',
    WebkitFlexDirection: 'column',
  },

  container2: {
    display: '-webkit-box',
    display: '-moz-box',
    display: '-ms-flexbox',
    display: '-webkit-flex',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    flexShrink: 0,
    flexBasis: 'auto',
    justifyContent: 'stretch',
    alignItems: 'flex-start',
    WebkitBoxOrient: 'vertical',
    WebkitBoxDirection: 'normal',
    WebkitFlexDirection: 'column',
    WebkitFlexGrow: 1,
    WebkitFlexShrink: 0,
    WebkitFlexBasis: 'auto',
    WebkitBoxPack: 'stretch',
    WebkitJustifyContent: 'stretch',
    WebkitBoxAlign: 'start',
    WebkitAlignItems: 'flex-start',
  },
  navItemStyle: {
    flex: 1,
    color: Colors.SidebarMenuText,
    textAlign: 'right',
    color: Colors.Black,
    marginRight: 20
  },
  navSectionStyle: {
    backgroundColor: 'lightgrey'
  },
  sectionHeadingStyle: {
    paddingVertical: 10,
    paddingHorizontal: 5
  },
  footerContainer: {
    height: 20,
    backgroundColor: Colors.SidebarMenuHeader
  },
  headerContainer: {
    padding: 20,
    textDecoration: 'none',
    display: 'flex',
    // width: '100%',
    backgroundColor: Colors.SidebarMenuHeader,
    flexDirection: 'row-reverse',
    WebkitBoxPack: 'justify', justifyContent: 'space-between'
  },


  navigationBar: {
    height: 50,
    paddingLeft: 20,
    paddingRight: 20,
    borderBottomColor: 'gray',
    display: 'flex',
    borderBottomWidth: 1,
    WebkitBoxOrient: 'horizontal', flexDirection: 'row',
  },
  navigatioBarLeft: {
    WebkitBoxOrient: 'horizontal', flexDirection: 'row',
    display: 'flex',

    WebkitBoxPack: 'start',
    justifyContent: 'flex-end',
    alignItems: 'center', WebkitBoxAlign: 'center',
    flex: 1
  },
  navigatioBarRight: {
    WebkitBoxOrient: 'horizontal', flexDirection: 'row',
    display: 'flex',

    WebkitBoxPack: 'end',
    justifyContent: 'flex-end',
    alignItems: 'center', WebkitBoxAlign: 'center',
    flex: 1
  },
  navigatioBarCenter: {
    display: 'flex',
    WebkitBoxOrient: 'horizontal', flexDirection: 'row',
    justifyContent: 'center',
    WebkitBoxPack: 'center',
    alignItems: 'center', WebkitBoxAlign: 'center',
    flex: 5
  },
  navigatioBarCenterText: {
  },
  chargeAccountText: {
    textAlign: 'right',
    color: Colors.White,
    fontSize: 15,
    fontWeight: '900',
    textShadowColor: 'rgba(0, 0, 0, 0.75)',
    textShadowOffset: { width: -1, height: 1 },
    textShadowRadius: 10
  },
  chargeAccountAmount: {
    textAlign: 'right',
    color: Colors.White,
    fontSize: 15,
    // fontWeight: '900',
    textShadowColor: 'rgba(0, 0, 0, 0.75)',
    textShadowOffset: { width: -1, height: 1 },
    textShadowRadius: 10

  },

  footerText: {
    marginRight: 20,
    textAlign: 'right',
    color: Colors.White,
    fontSize: 12,
    fontWeight: '900',
    textShadowColor: 'rgba(0, 0, 0, 0.75)',
    textShadowOffset: { width: -1, height: 1 },
    textShadowRadius: 10
  },
  navItemsContainer: {
    WebkitBoxOrient: 'vertical', flexDirection: 'column',
    display: 'flex',
    justifyContent: 'center',
    WebkitBoxPack: 'center',
    alignItems: 'flex-end', WebkitBoxAlign: 'end',
    flex: 1,
    paddingRight: 10,
    marginTop: 5,
    marginBottom: 5
  },
  navItemsdiv: {
    WebkitBoxOrient: 'vertical', flexDirection: 'column',
    display: 'flex',
    borderWidth: 1,
    flex: 1
  },
  navItemRow: {
    WebkitBoxOrient: 'horizontal', flexDirection: 'row',
    display: 'flex',
    justifyContent: 'center',
    WebkitBoxPack: 'center',
    alignItems: 'center', WebkitBoxAlign: 'center',
    marginRight: 5,
    marginVertical: 10,
    width: '100%'
  },
  menuItems: {
    paddingRight: 5,
    // display: 'flex',
    // justifyContent: 'center',
    WebkitBoxPack: 'center',
    // alignItems: 'center', WebkitBoxAlign:'center',
    // width: '100%',
    flex: 1,
    textDecoration: 'none',

    WebkitBoxOrient: 'horizontal', flexDirection: 'row',
    display: 'flex',
    justifyContent: 'center',
    WebkitBoxPack: 'center',
    alignItems: 'center', WebkitBoxAlign: 'center',
    // marginRight: 5,
    marginVertical: 10,
    width: '100%'
  },

  navIcon: {
    width: 20,
    height: 20
  },
  modal: {
    borderRadius: 10,
    padding: 15,
    // justifyContent: 'center',
    WebkitBoxPack: 'center',
    display: 'flex',
    // alignItems: 'center', WebkitBoxAlign:'center',
    WebkitBoxOrient: 'vertical', flexDirection: 'column',
    backgroundColor: Colors.White,
  }
};
